import baseRoute from '../baseRoute';

type RouteDefinition = `${typeof baseRoute}/${number | ':materialGroupId'}`;

export const ROUTE: RouteDefinition = `${baseRoute}/:materialGroupId`;

export const URL = (materialGroupId: number): RouteDefinition => `${baseRoute}/${materialGroupId}`;
